export default __webpack_public_path__ + "assets/models/41873f8d29ba6986fbd989cc11a0861b.glb";